<router-outlet></router-outlet>
<tmw-loading-spinner></tmw-loading-spinner>
